$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
Controller = require 'app/scripts/controller'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
Confirm = require 'app/scripts/views/lib/confirm'
SharePopoverView = require 'app/scripts/views/board/share-popover-view'
EditEmailSettingsView = require 'app/scripts/views/board-menu/edit-email-settings-view'
CopyBoardView = require 'app/scripts/views/board/copy-board-view'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ Noun, Verb, track, trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
boardMenuMore = require 'app/scripts/views/templates/board_menu_more'
{ dontUpsell } = require '@trello/config'
ModelLoader = require 'app/scripts/db/model-loader'
BoardAddToTeam = require 'app/scripts/views/board-menu/board-add-to-team-view'
BoardMenuSettingsView = 'views/board-menu/board-settings-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
React = require 'react'
ReactDOM = require 'react-dom'
{ UpgradePromptFull } = require 'app/src/components/UpgradePrompts/UpgradePromptFull'
{ UpgradePromptPill } = require 'app/src/components/UpgradePrompts/UpgradePromptPill'
{ renderUpgradePrompt } = require 'app/src/components/UpgradePrompts/renderUpgradePrompt'
{ IconName } = require 'app/common/components/controls/icon'

TEMPLATES_ALERT_TIMEOUT = 1000

module.exports = class BoardMenuMoreView extends View
  viewTitleKey: 'more'

  initialize: ({ @sidebarView }) ->
    @makeDebouncedMethods 'render'

    @listenTo @model,
      'change:subscribed': @renderSubscribeState
      'change:prefs.isTemplate': @renderDebounced
      'change:prefs.permissionLevel': @renderDebounced
      'change:idOrganization': @renderDebounced
      'change:memberships': @renderDebounced

    @listenTo @model, 'cancel-add-to-team', =>
      @addToTeam = false
      @render()
    @listenTo @model, 'add-to-team', =>
      if !@model.owned()
        # We aren't an admin on this board so redirect to business-class page
        window.location = '/business-class'
      else
        @addToTeam = true
        @render()

    @templateFlagEnabled = @sidebarView.templateFlagEnabled
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @templateFlagEnabled = newVal
      @renderDebounced()

  className: 'board-menu-content-frame'

  events:
    'click .js-open-collections': 'openCollections'
    'click .js-open-settings': 'openSettings'
    'click .js-open-stickers': 'openStickers'
    'click .js-open-labels': 'openLabels'
    'click .js-open-archive': 'openArchivedItems'
    'click .js-share': 'shareBoard'
    'click .js-email': 'openEmailSettings'
    'click .js-board-subscribe': 'toggleSubscribe'
    'click .js-copy-board': 'copyBoard'
    'click .js-close-board': 'closeConfirm'
    'click .js-leave-board': 'leaveConfirm'
    'click .js-short-url': 'selectUrl'
    'click .js-create-template': 'createTemplate'
    'click .js-convert-to-board': 'convertToBoard'
    'submit form': 'cancel'

  remove: ->
    @unmountCollectionsPromptPill?()
    @unmountCollectionsPromptFull?()
    super

  render: (e) ->
    # clears sidebar menu
    @$el.empty()

    me = Auth.me()
    board = @model

    data = @model.toJSON()
    data.canJoin = @model.canJoin()
    data.canInviteMembers = @model.canInviteMembers()
    data.confirmed = me.get('confirmed')
    data.isLoggedIn = me.isLoggedIn()

    org = @model.getOrganization()

    orgBillingUrl = if org then Controller.getOrganizationBillingUrl(org)

    data.canCloseBoard = @model.owned() || (org?.isFeatureEnabled('superAdmins') && org?.owned())

    data.editableByMember = @model.editableByMember(me)
    data.canLeaveBoard = (@model.isMemberObserver(me) || @model.editableByMember(me)) && me.getMembershipData(@model).canRemove
    data.canCloseOrLeave = data.canLeaveBoard || data.canCloseBoard

    data.pLevelClass = BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)
    data.pLevelAltText = BoardDisplayHelpers.getPermLevelAltTextForBoard(@model)
    data.helperText = l(['board perms', @model.getPermLevel(), 'short summary'])

    collectionsEnabled = org?.isFeatureEnabled('tags')
    data.showCollections = collectionsEnabled || !dontUpsell

    data.templateFlagEnabled = @templateFlagEnabled
    data.isTemplate = @model.isTemplate()
    data.templateModeEnabled = @templateFlagEnabled && @model.isTemplate()
    data.hasMadeTemplate = Auth.me().isDismissed('made-first-template')
    data.hasMultipleMembers = @model.get('memberships')?.length > 1
    data.canBeTemplate = @model.getPermLevel() != 'private'
    data.isAtOrOverFreeBoardLimit = @model.getOrganization()?.isAtOrOverFreeBoardLimit()
    data.isOrgBcOrEnt = !!(org?.isBusinessClass() || org?.belongsToRealEnterprise())

    if @addToTeam
      @renderAddToTeam()
    else
      @$el.html(boardMenuMore(data))

      @unmountCollectionsPromptPill = renderUpgradePrompt(
        React.createElement(UpgradePromptPill, {
          iconName: IconName.BusinessClass
          cta: l(['upgrade prompt', 'upgrade'])
          ctaLink: orgBillingUrl
          ctaTrackEvent: ->
            trackUe({
              category: Noun.BOARD_MENU,
              verb: Verb.OPENS,
              directObj: Noun.TEAM_PAGE_BC_TAB,
              method: 'by clicking pill upgrade prompt in board menu more section'
            })
        })
        , @$el.find('.js-board-menu-pill-collections-upgrade')[0]
        , {
          boardModel: board
        }
      )

      @unmountCollectionsPromptFull = renderUpgradePrompt(
        ({ dismiss }) ->
          React.createElement(UpgradePromptFull, {
            headline: l(['upgrade prompt', 'board menu', 'collections', 'headline-2']),
            content: l(['upgrade prompt', 'board menu', 'collections', 'content-2']),
            cta: l(['upgrade prompt', 'learn more']),
            ctaLink: orgBillingUrl,
            ctaTrackEvent: ->
              trackUe({
                category: Noun.BOARD_MENU,
                verb: Verb.OPENS,
                directObj: Noun.TEAM_PAGE_BC_TAB,
                method: 'by clicking full upgrade prompt in board menu more section'
              })
            iconName: IconName.Collection,
            isDismissable: true
            onDismiss: dismiss
          })
        , @$el.find('.js-board-menu-prompt-collections')[0]
        , {
            promptID: 'ad-bc-prompt-upgrade-board-more-collection'
            boardModel: @model
          }
      )

      @renderSubscribeState()

    @

  renderAddToTeam: ->
    ModelLoader.loadMyOrganizations()

    @appendSubview @subview(BoardAddToTeam, @model, {
      menuType: "More"
    })

  renderSubscribeState: ->
    @$('.js-subscribed-state').toggleClass('hide', !@model.get('subscribed'))
    return

  openCollections: (e) ->
    Util.stop(e)

    @sidebarView.pushView 'collections'
    return

  openSettings: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'settings'
    return

  openLabels: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'labels'
    return

  openStickers: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'stickers'
    return

  openArchivedItems: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'archive'
    return

  shareBoard: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$(e.target).closest('.js-share')
      view: new SharePopoverView({ @model, @modelCache })

    track("Board Menu", "Open Share, Print, and Export Menu")

    return

  openEmailSettings: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$(e.target).closest('.js-email')
      view: new EditEmailSettingsView({ @model, @modelCache })

    track('Board Menu', 'Open Email Settings - Menu')

    return

  copyBoard: (e) ->
    Util.stop(e)

    if !$(e.target).hasClass('disabled')
      track("Board Menu", "Open Copy Board")

      PopOver.toggle
        elem: @$(e.target).closest('.js-copy-board')
        view: new CopyBoardView({ @model, @modelCache })

    return

  toggleSubscribe: (e) ->
    Util.preventDefault(e)

    if !$(e.target).hasClass('disabled')
      @model.subscribe !@model.get('subscribed')
      track("Board Menu", "Subscribe/Unsubscribe")

    return

  closeConfirm: (e) ->
    Util.stop(e)
    track("Board Menu", "Open Close Menu")

    Confirm.toggle 'close board',
      elem: $(e.target).closest('a')
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.close()
        track("Board", "Close Board")

    return

  leaveConfirm: (e) ->
    Util.stop(e)
    track("Board Menu", "Open Leave Menu")

    me = Auth.me()
    key = me.removeMembershipConfirmationKey(@model)

    Confirm.toggle key,
      elem: $(e.target).closest('a')
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.removeMember(me)
        track("Board", "Leave Board")

    return

  selectUrl: (e) ->
    @$('.js-short-url').focus().select()

  cancel: (e) ->
    Util.stop(e)
    false

  createTemplate: (e) ->
    Util.stop(e)

    if !$(e.target).hasClass('disabled')
      PopOver.toggle
        elem: @$(e.target).closest('.js-create-template')
        view: new CopyBoardView({
          @templateFlagEnabled,
          @model,
          @modelCache,
          boardNameInputValue: @model.get('name')
          toTemplate: true
        })

  convertToBoard: ->
    Alerts.show('converting', 'info', 'templates', TEMPLATES_ALERT_TIMEOUT)
    @model.setPref('isTemplate', false).save()

    # Reset board preferences to defaults
    @model.setPref('comments', 'members').save()
    @model.setPref('selfJoin', true).save()

    trackUe('board menu', 'converts', 'template', 'to board', '', 'by clicking template toggle',
      { boardId: @model.id, teamId: @model.getOrganization()?.id })

